import { useEffect, useMemo } from 'react';
import { useAuthStore } from '../store/authStore';
import { resolveSubscriptionStatus } from './subscriptionUtils';

export function useSubscriptionStatus(appKey = null) {
  const user = useAuthStore((state) => state.user);
  const refreshApps = useAuthStore((state) => state.refreshApps);

  useEffect(() => {
    if (appKey) refreshApps();
  }, [appKey, refreshApps]);

  return useMemo(() => {
    if (!user?.apps) {
      return appKey
        ? { status: 'NO_ACCESS', daysLeft: 0, expiresAt: null, expiresAtLabel: null }
        : {};
    }

    const allStatuses = {};

    Object.entries(user.apps).forEach(([key, access]) => {
      allStatuses[key] = resolveSubscriptionStatus(access);
    });

    return appKey
      ? allStatuses[appKey] || {
          status: 'NO_ACCESS',
          daysLeft: 0,
          expiresAt: null,
          expiresAtLabel: null,
        }
      : allStatuses;
  }, [user, appKey]);
}
